export default "__VITE_ASSET__C6pHKL_X__"